/* global axios */
import ApiClient from '../ApiClient';

class HistoryApiErrors extends ApiClient {
  constructor() {
    super('history_api_errors', { accountScoped: true });
  }

  getAll({ startDate = null, endDate = null } = {}) {
    const params = {};

    if (startDate && endDate) {
      params.start_date = startDate;
      params.end_date = endDate;
    }

    return axios.get(this.url, { params });
  }
}

export default new HistoryApiErrors();
